import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-kyc',
  templateUrl: './dashboard-kyc.component.html',
  styleUrls: ['./dashboard-kyc.component.scss']
})
export class DashboardKycComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
